'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Content;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Content(props) {
  var label = props.label,
      children = props.children;

  if (children || children === 0) {
    return _react2.default.createElement('span', {
      className: 'rainbow-badge_content--truncate'
    }, children);
  }

  return _react2.default.createElement('span', {
    className: 'rainbow-badge_content--truncate'
  }, label);
}

Content.propTypes = {
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  children: _propTypes2.default.node
};
Content.defaultProps = {
  label: null,
  children: null
};